import { onBeforeUnmount } from 'vue';

export function useCloseOnEscape(callBack) {
  const handleKeyEvent = (event) => {
    if (event.key === 'Escape') {
      callBack();
    }
  };

  document.addEventListener('keyup', handleKeyEvent);

  onBeforeUnmount(() => {
    document.removeEventListener('keyup', handleKeyEvent);
  });
}
